import environment from "environment";
import { BaseModel } from "sjs-base-model";

export default class SimulazioneStepTwoFormModel extends BaseModel {
    public readonly nome: string = "";
    public readonly convenzione: string = "";
    public readonly fasciaSottoLivelli: string = environment.defaultIdSubLevel;

    constructor(data: Partial<SimulazioneStepTwoFormModel>) {
        super();

        this.update(data);
    }
}
